import App from './App.svelte';


window.createCalendar = function (target, props) {

	return new App({
		target: target,//document.getElementById(target),
		hydrate: true,
		props: props
		// {
		// 	onSelect: function(date){
		// 		console.log("Selected", date);}, 
		// 	availableDates: function(selected) { 
		// 		return selected == "2023-06-17";
		// 	},
		// 	dateFormat: 'YYYY-MM-DD',
		// 	title:"Select date",
		// 	locale:"en"
		// },
	});
};
